import { batch } from 'react-redux';
import dataSources from 'dataSources';
import { AppThunk } from 'store';
import { AuthForm } from 'dataSources/Typicode/auth/types/authToken';
import { STATUS_LOADING } from 'common/constants/statusLoading';
import setAuthData from 'common/utils/auth/setAuthData';
import resetAuthData from 'common/utils/auth/resetAuthData';
import parseAuthData from 'common/utils/auth/parseAuthData';
import { deleteCountRefreshPage } from 'common/utils/auth/countRefresgPage';
import { USER_TYPES } from 'common/utils/userTypes';
import getTranslateIdFromResponseError from 'common/utils/getTranslateIdFromResponseError';

import slice from '../reducer/slice';
import appSlice from '../../application/reducer/slice';

const { setUserType, setUserLoadingStatus } = slice.actions;
const { setError } = appSlice.actions;

const operation =
  (authForm: AuthForm): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setUserLoadingStatus(STATUS_LOADING.load));
      deleteCountRefreshPage();

      const { data } = await dataSources.auth.getAuthTokens(authForm);

      const authData = parseAuthData(data);
      await setAuthData(authData);

      window.location.reload();
    } catch (e) {
      const translateId = await getTranslateIdFromResponseError(e);
      batch(() => {
        dispatch(setError({ translateId }));
        resetAuthData();
        dispatch(setUserLoadingStatus(STATUS_LOADING.error));
        dispatch(setUserType(USER_TYPES.unautorized));
      });
    }
  };

export default operation;
